import { MergedEventsSection } from '../../../event-panel/tabs/merged-events/components/sections/merged-events-section';
import { useGetEventIdAndTabNameFromParams } from '../../hooks/use-get-event-id-and-tab-name-from-params';
import { FrTabContentWrapper } from './styled';

export default function FrMergedEventsTab() {
    const { eventId } = useGetEventIdAndTabNameFromParams();

    return (
        <FrTabContentWrapper>
            {eventId && <MergedEventsSection eventId={eventId} />}
        </FrTabContentWrapper>
    );
}
